import React from "react";
// Discover Data
import { DiscoverData } from "./DiscoverData";
// Discover Card
import DiscoverCard from "./DiscoverCard";

const Discover = () => {
  return (
    <>
      <section id="go_beyond_area" className="section_padding_top">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
              <div className="heading_left_area">
                <h2>
                  Discover Beyond <span>Boundaries</span>
                </h2>
                <h5 className="text-justify">
                  At House of Polani, we don't just plan trips. We craft
                  journeys that surpass your imagination. Let us guide you to
                  experiences that redefine luxury travel.
                </h5>
              </div>
            </div>
            {DiscoverData.map((data, index) => (
              <DiscoverCard data={data} key={index} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Discover;
